import { useViewSistema } from '../../../hooks/useView'

export function MenuItem(props){
    const { addView } = useViewSistema()

    return (
        <li className="nav-item" title={props.menu.nome}>
            <a href={props.menu.link || '#'} onClick={() => {
                if (props.menu.chave) {
                    addView(props.menu)
                }
            }} className="nav-link">
                <i className={`fas fa-${props.menu.icone} nav-icon`}></i>
                <p>{props.menu.nome}</p>
            </a>
        </li>
    )
}